import { defaultMapCenter } from 'components/MapComponent/constants';
import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { resetFoundLayerAction } from 'store/actions/layers';
import {
  toggleOpenClusterModalAction,
  toggleOpenLayerModalAction,
} from 'store/actions/mainPage';
import { BackdropLoad } from 'components/UI/Backdrop';
import { ClusterModal } from 'components/UI/ClusterModal';
import { LayerInfoModal } from 'components/UI/LayerInfoModal';
import { MapElements } from 'components/MapElements';
import { MapComponent } from 'components/MapComponent';
import { DynamicSeriesSlider } from 'components/UI/DynamicSeriesSlider';
import {
  FullScreenControl,
  ScaleLineControl,
  ZoomControl,
  ZoomToExtentControl,
} from 'components/MapComponent/Controls';
import { MapToolbar } from 'components/MapToolbar';
import { Box, Link } from '@mui/material';

export const MapBlock: React.FC = () => {
  const [open, setOpen] = useState(true);
  const [bounds, setBounds] = useState([
    1894627.1204415485, 6880958.860838083, 4242772.629362163, 7421521.524870849,
  ]);
  const { isOpenLayerInfo, backdropLoading, isOpenClusterInfo } =
    useAppSelector((state) => state.mainPage);
  const { foundInfo, currAteRegion } = useAppSelector((state) => state.layers);
  const dispatch = useAppDispatch();

  const toggleOpen = (open: boolean) => {
    setOpen(open);
  };

  const handleCloseInfo = () => {
    dispatch(toggleOpenLayerModalAction());
    if (!currAteRegion?.id) {
      dispatch(resetFoundLayerAction());
    }
  };

  const handleCloseClusterInfo = () => {
    dispatch(toggleOpenClusterModalAction(false));
    dispatch(resetFoundLayerAction());
  };

  return (
    <Box
      sx={{
        width: '100vw',
        height: 'calc(100vh - 48px)',
        display: 'flex',
        position: 'relative',
      }}
    >
      <MapToolbar open={open} toggleOpen={toggleOpen} />
      <Box
        id={'fs-box'}
        sx={{ width: '100%', height: '100%', position: 'relative' }}
      >
        <MapComponent
          toolbarOpen={open}
          center={defaultMapCenter}
          headerHeight={48}
        >
          <Box>
            <ZoomControl />
          </Box>
          <FullScreenControl />
          <ScaleLineControl />
          <ZoomToExtentControl bounds={bounds} />
          <ClusterModal />
          <LayerInfoModal />
          <Box
            sx={{ position: 'absolute', right: 25, bottom: 5, zIndex: 1000 }}
          >
            <Link
              underline="hover"
              target="_blank"
              href="https://openstreetmap.org/copyright"
            >
              © OpenStreetMap
            </Link>
          </Box>
          <DynamicSeriesSlider />
        </MapComponent>
        <MapElements />
      </Box>
      <BackdropLoad
        isOpen={backdropLoading}
        drawerWidth={open ? '435px' : '50px'}
      />
    </Box>
  );
};
